import { render, staticRenderFns } from "./SettingAlliance.vue?vue&type=template&id=8ce9daa8&scoped=true&"
import script from "./SettingAlliance.vue?vue&type=script&lang=js&"
export * from "./SettingAlliance.vue?vue&type=script&lang=js&"
import style0 from "./SettingAlliance.vue?vue&type=style&index=0&id=8ce9daa8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce9daa8",
  null
  
)

export default component.exports